export default __webpack_public_path__ + "static/media/Lapis3.b651bc78.jpg";